import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=2befd8c2&scoped=true&"
import script from "./MemberTable.vue?vue&type=script&lang=js&"
export * from "./MemberTable.vue?vue&type=script&lang=js&"
import style0 from "./MemberTable.vue?vue&type=style&index=0&id=2befd8c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2befd8c2",
  null
  
)

export default component.exports